import React from 'react';
import styled from 'styled-components';
import { media } from '../../../utils/style-utils';

import Cnhi from '../../../assets/images/login/customers/CNHI_logo.jpg';
import Yarraranges from '../../../assets/images/login/customers/Yarraranges_logo.jpg';
import Wilmar from '../../../assets/images/login/customers/Wilmar_logo.jpg';

const CustomersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const CustomersCaption = styled.span`
  text-align: center;
  color: #9e9e9e;
  font-family: ${props => props.theme.font.bold};
`;

const Customers = styled.div`
  padding: 32px 30px 12px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

const Customer = styled.img`
  height: 76px;
  padding: 0 40px;
  margin-bottom: 40px;

  ${media.mobile`
    padding: 0 20px;
    margin-bottom: 20px;
  `};
`;

class LoginCustomers extends React.Component {
  render() {
    return (
      <CustomersWrapper>
        <CustomersCaption>Our Customers</CustomersCaption>
        <Customers>
          <Customer src={Cnhi} alt="CNHI" />
          <Customer src={Yarraranges} alt="Yarra Ranges" />
          <Customer src={Wilmar} alt="Wilmar" />
        </Customers>
      </CustomersWrapper>
    );
  }
}

export default LoginCustomers;



// WEBPACK FOOTER //
// ./src/features/login/login-customers/LoginCustomers.js